// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5013":"342e14eb","5930":"7fd3522c"}[chunkId] + ".chunk.css";
};